export const COMMON_REQ = 'cris/executive/COMMON_REQ';
export const COMMON_REQ_FAIL = 'cris/executive/COMMON_REQ_FAIL';

export const LOAD_EXECUTIVES_SUCCESS = 'cris/executive/LOAD_EXECUTIVES_SUCCESS';

const initialState = {
	isLoading: false,
	error: null,
	users: []
};

export default (state = initialState, action) => {
	switch (action.type) {
		case COMMON_REQ:
			return {
				...state,
				isLoading: true
			};

		case COMMON_REQ_FAIL:
			return {
				...state,
				isLoading: false,
				error: action.error
			};

		case LOAD_EXECUTIVES_SUCCESS:
			const users = action.payload.data.users.map((item) => ({
				id: item.id,
				name: item.name || '',
				email: item.email,
				contact_office: item.contact_office || '',
				contact_home: item.contact_home || '',
				status: item.status
			}));

			return {
				...state,
				isLoading: false,
				users: users
			};

		default:
			return state;
	}
}